import environmentVariables from '../app/environmentVariables';

/**
 * GET `/launch/network-status` — public live screen status for marketing.
 */
export async function getNetworkStatus() {
    const res = await fetch(`${environmentVariables().REACT_APP_API_URL}/launch/network-status`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to load network status');
    }
    return data;
}
